import { create } from 'zustand';

interface CommentDeleteRow {
  id: number;
}

interface CommentDeleteState {
  isOpen: boolean;
  row: CommentDeleteRow;
  type: string;
  onCommentDeleteClose: () => void;
  onCommentDeleteOpen: (row: CommentDeleteRow, type: string) => void;
}

export const useCommentDeleteStore = create<CommentDeleteState>(set => ({
  isOpen: false,
  row: { id: 0 },
  type: '',
  onCommentDeleteClose: () => set({ isOpen: false, type: '' }),
  onCommentDeleteOpen: (row, type) => set({ isOpen: true, row, type }),
}));
